import getBlocksReadableNames from './get-blocks-readable-names';
import getLargestBlock from './get-largest-block';

export default {
  getBlocksReadableNames,
  getLargestBlock,
};
